// @flow

import qs from 'qs';

export default async (opts) => {
  if (!opts.url) throw 'No url passed'
  // Prefix with domain
  if (opts.url.charAt(0) === '/')
    opts.url = 'http://localhost:1338' + opts.url

  if (opts.body)
    opts.body = JSON.stringify(opts.body)

  if (opts.method === 'GET' && opts.query)
    opts.url += `?${qs.stringify({ query: opts.query })}`

  return await fetch(opts.url, opts)
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {

      // Expected error. Server returned an {err: "some message"} obj
      if (err.err) throw new Error(err.err)
      // Unexpected error. This must be handled by the caller.
      else throw err

    })
}


// WEBPACK FOOTER //
// ./src/services/fetch.js